import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import { loginUser } from 'js/library/services/AuthenticationManager.js';
import cfac22 from '../cfac22';

export default function createAnonymous() {
  return new Promise((resolve, reject) => {
    authToken(null)
      .then((token) => {
        axios
          .post(
            `${cfac22('API_HOST_V2')}/anonymous/create`,
            {
              partnerId: 'Triibo',
            },
            {
              headers: { authorization: `Bearer ${token}`, 'Full-Url': window.location.href },
            }
          )
          .then(async (result) => {
            // console.log("RESULT_CREATE_ANONYMOUS: ", result);
            const triiboId = result.data.triiboId.replaceAll(',', '.');

            localStorage.setItem('userInfoAuxiliar', JSON.stringify({ ...result.data, triiboId }));
            await loginUser(result.data.triiboId.replaceAll(',', '.'), result.data.passPhrase);

            resolve(result.data);
          })
          .catch((error) => {
            //console.log("ERROR_CREATE_ANONYMOUS: ", error);
            return reject(error);
          });
      })
      .catch((error) => {
        //console.log("ERROR_TOKEN:", error);
        reject(error);
      });
  });
}
